const GA_ID = "G-690MSLPHCR";
const YM_ID = 108526044;
const META_PIXEL_ID = "945618748377866";
export const META_PIXEL_READY_EVENT = "nailretouch:meta-pixel-ready";
export const YANDEX_CLIENT_ID_READY_EVENT = "nailretouch:yandex-client-id-ready";

let initialized = false;

function loadScript(src) {
  if (document.querySelector(`script[src="${src}"]`)) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
}

function initMetaPixel() {
  if (!window.fbq) {
    const fbq = (window.fbq = function fbq() {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, arguments);
      } else {
        fbq.queue.push(arguments);
      }
    });

    if (!window._fbq) {
      window._fbq = fbq;
    }

    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    loadScript("https://connect.facebook.net/en_US/fbevents.js");
  }

  window.fbq("init", META_PIXEL_ID);
  window.fbq("track", "PageView");
  window.nailretouchMetaPixelReady = true;
  window.dispatchEvent(new Event(META_PIXEL_READY_EVENT));
}

export function initAnalytics() {
  if (typeof window === "undefined" || initialized) return;

  initialized = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, {
    anonymize_ip: true,
  });
  loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`);

  window.ym =
    window.ym ||
    function ym() {
      (window.ym.a = window.ym.a || []).push(arguments);
    };
  window.ym.l = Number(new Date());
  window.ym(YM_ID, "init", {
    clickmap: false,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: false,
    trackHash: false,
  });
  window.ym(YM_ID, "getClientID", (clientId) => {
    if (!clientId) return;

    window.nailretouchYandexClientId = String(clientId);
    window.dispatchEvent(new Event(YANDEX_CLIENT_ID_READY_EVENT));
  });
  loadScript("https://mc.yandex.ru/metrika/tag.js");

  initMetaPixel();
}

export function trackLead() {
  if (typeof window === "undefined") return;

  if (typeof window.fbq === "function") {
    window.fbq("track", "Lead", {
      value: 0.01,
      currency: "USD",
    });
  }

  if (typeof window.ym === "function") {
    window.ym(YM_ID, "reachGoal", "tg-click");
  }
}
